import { RootState } from "@app/store/types";
import { Auth, userSlice } from "@entities/user";
import { BaseQueryFn, FetchArgs, fetchBaseQuery, FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { APP_CONFIG } from "@shared/config";


export const _backendBaseQuery = fetchBaseQuery({
    baseUrl: APP_CONFIG.backendURL,
    prepareHeaders: (headers, {getState}) => {
        const accessToken = (getState() as RootState)["user-slice"]?.auth?.accessToken
        if (accessToken) {
            headers.set('Authorization', `Bearer ${accessToken}`);
        }
        return headers;
    }
}) 

export const backendBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> 
  = async (args, api, extraOptions) => {
    let result = await _backendBaseQuery(args, api, extraOptions);

    if(!result.error) return result
    if(result.error.status !== 401) return result

    const state = api.getState() as RootState;
    const refreshToken = state['user-slice']?.auth?.refreshToken;

    if (!refreshToken) {
      api.dispatch(userSlice.actions.logout());
      return result;
    }

    const refreshResult = await _backendBaseQuery(
      {
        url: '/auth/refresh',
        method: 'POST',
        body: { refreshToken },
      },
      api,
      extraOptions,
    );

    if (refreshResult.data) {
      const { accessToken, refreshToken } =
        refreshResult.data as Auth

      api.dispatch(
        userSlice.actions.login({
          accessToken,
          refreshToken
        }),
      );

      result = await _backendBaseQuery(args, api, extraOptions);
    } else {
      api.dispatch(userSlice.actions.logout());
    }
    

    return result;
  } 